export default function MailHeader() {
    return (
        <svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.2 0.666504H1.46667C0.66 0.666504 0.00733333 1.354 0.00733333 2.19428L0 11.3609C0 12.2012 0.66 12.8887 1.46667 12.8887H13.2C14.0067 12.8887 14.6667 12.2012 14.6667 11.3609V2.19428C14.6667 1.354 14.0067 0.666504 13.2 0.666504ZM13.2 3.72206L7.33333 7.5415L1.46667 3.72206V2.19428L7.33333 6.01373L13.2 2.19428V3.72206Z" fill="#43656E"/>
</svg>


    )
}